<template lang="jade">
    //-include ../node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle.jade

    .asw-results(:class="{ 'asw-fullscreen': fullscreen }")
        .asw-map_title(v-if="title")|{{ title }}

        MapSVG(v-if="results", :geodata="geodata", :results="results", :fullscreen="fullscreen", :emojiData="emojiData", :environ="environ", :resultDate="resultDate" , @fullscreen="onFullscreen", @closeElecPoll="closeElecPoll")
        LoadingOverlay(v-else)
        EmojiLegend(:emojiData="emojiData")
        

</template>

<script>

    import geodata from '@/store/mapboundaries.json';
    import emojiData from '@/store/emojiData.json';
    import LoadingOverlay from '@/components/LoadingOverlay.vue';
    import MapSVG from '@/components/MapSVG.vue';
    import EmojiLegend from '@/components/EmojiLegend.vue';
    import axios from 'axios'

    export default {
        name: 'app',
        data: () => ({
            geodata,
            results:null,
            emojiData,
            fullscreen: false,
            environ: null,
            resultDate: 1558166400000 // 6pm, 18th of May, 2019 local epoch timestamp in milliseconds. www.epochconverter.com
            //resultDate: 1556162760000 // test date
        }),
        components: {
            MapSVG,
            EmojiLegend,
            LoadingOverlay
        },
        computed: {
            title() {
                const 
                    title = "How does this campaign make you feel?",
                    titleElectionNight = "How do the election results make you feel?";
                return ( Date.now() > this.resultDate ) ? titleElectionNight: title;
			}
        },
        mounted() {
            // console.log('that',this);
        },
        created () {
            this.whatEnvironment();
            this.getOverall();
        },
        methods: {
            whatEnvironment() {
				const
					envParam = (location.search.match(/env=([^&]+)/) || [])[1],
					uatDomain = location.host.match('uat.com.au') && 'uat',
					env = envParam || uatDomain || process.env.NODE_ENV || 'development';

				this.environ = env;
			},
            onFullscreen(isFullscreen) {
                //console.log('onFullscreen', isFullscreen)
                this.fullscreen = isFullscreen;
            },
            closeElecPoll() {
				this.getOverall();
			},
            getOverall() {
                
                const 
                    uatUrl = 'https://d3l0ncuayaqpnv.cloudfront.net/static/overall-sentiment.json',
                    prodUrl = 'https://d1pg15zwxj87d2.cloudfront.net/static/overall-sentiment.json',
                    //getUrl = this.environ == "development" ||  ? uatUrl : prodUrl ;
                    getUrl = this.environ.match(/development|uat/) ? uatUrl : prodUrl ;

                //axios.get('https://znj95mx1a2.execute-api.ap-southeast-2.amazonaws.com/uat/api/overall')
                axios.get(getUrl)
                    .then((response) => {
                        this.results = response.data.data;
                    })
                    //.catch(function (error) {
                    .catch((error) => {
                        console.log(error);
                        setTimeout( () => this.getOverall(), 6000 );
                    });
            }
        },
        watch: {
            fullscreen() {
                document.body.setAttribute('asw-fullscreen', this.fullscreen);
            }
        }
    }
</script>

<style lang="scss">

	@import "src/assets/scss/global-sass";
	@import "node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle";
	@import "node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle-dependencies";

    body[asw-fullscreen] .reimagine-main {
        z-index: auto !important;
    }

    .asw-results {
        width: 100%; //677px;
        @include tgs-font-base-m;
        border: 1px solid #d3d3d3;
        margin-bottom: $m-spacing-x4;
        position:relative;
        z-index: 10;
        background: #fff;
        overflow:hidden;

        * {
            box-sizing: border-box;
        }

        &.asw-fullscreen {
            position: fixed;
            top: 50px;
            height: 100%;
            height: calc(100vh - 50px);
            left: 0;
            width: 100%;
            // height: 100%;
            background: #fff;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            z-index: 100000;

            body.newscomau & {
                z-index: 10;
                top: 40px;
                padding-top: 10px;
                height: calc(100vh - 40px);
            }
            // NRM
            .recurring-inline-full & {
                z-index: 10;
                top: 31px;
                padding-top: 10px;
                height: calc(100vh - 31px);
            }
        }

        body.newscomau &:not(.asw-fullscreen) .tge-componenttitle {
            padding: $m-spacing 0;
		}


    }

    .asw-map_title {
        flex: 0 0 40px;

        font-size:1.4em;
        font-weight: bold;
        margin:10px 5px;
    }

    .asw-color-legend {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .asw-colorblock {
        display: inline-block;
        height: 12px;
        width: 12px;
        margin: 1px;
    }

    /* Global Transitions */
    .fade-leave { opacity: 0.3; }

	.fade-enter,
	.fade-leave-to { opacity: 0; }

	.fade-enter-active { transition: all 0.3s 0s; }
	.fade-leave-active { transition: all 0.1s 0s; }

</style>



// WEBPACK FOOTER //
// src/App.vue